export default "__VITE_ASSET__CWNoTmai__"